import { Action } from 'redux';
import { isGetPersonalSpaceSuccededAction } from '../actions/PersonalSpaceActions';
import { PersonalSpaceInfo } from '../../ts/restApi/personalSpace/PersonalSpace';

const defaultPersonalSpaceInfo: PersonalSpaceInfo = {
  luid: '',
  ownerLuid: '',
  readOnly: true
};

export function personalSpaceReducer(previousState: PersonalSpaceInfo = defaultPersonalSpaceInfo, action: Action): PersonalSpaceInfo {
  if (isGetPersonalSpaceSuccededAction(action)) {
    return ({
      luid: action.personalSpace.luid,
      ownerLuid: action.personalSpace.ownerLuid,
      readOnly: action.personalSpace.readOnly,
    });
  }

  return previousState;
}